module.exports = __webpack_public_path__ + "img/SketchPng7cf749a01d6af3ca5c624229913a8d12e9fde48c1dc569632811efeb52b380a2.5c06ce73.png";